import * as React from 'react';

const SaralLogoPDFPreviewPage = React.forwardRef((props, ref) => (
  <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width="166" height="48" fill="none" viewBox="0 0 166 48" {...props}>
    <path
      fill="url(#paint0_linear_34151_47857)"
      fillRule="evenodd"
      d="M26.695 29.62a6.07 6.07 0 0 0 .755-8.552l-.273-.326 4.373-3.661.273.325c4.18 4.984 3.524 12.409-1.463 16.585z"
      clipRule="evenodd"></path>
    <path
      fill="url(#paint1_linear_34151_47857)"
      fillRule="evenodd"
      d="m18.831 27.726.274.326-4.374 3.661-.273-.325c-4.18-4.984-3.524-12.409 1.463-16.585l3.665 4.37a6.07 6.07 0 0 0-.755 8.553"
      clipRule="evenodd"></path>
    <path
      fill="#7F38E9"
      fillRule="evenodd"
      d="m32.384 36.071-7.237-8.63-3.945 10.51zM13.92 12.731l7.237 8.63 3.946-10.51z"
      clipRule="evenodd"></path>
    <path
      fill="#212121"
      d="M47.146 26.852h3.807q.113.96.875 1.749.789.761 2.058 1.212 1.27.423 2.849.423 1.438 0 2.368-.31t1.382-.874q.452-.564.452-1.354 0-.761-.564-1.156-.565-.423-1.777-.677-1.212-.282-3.187-.564a22 22 0 0 1-2.933-.62q-1.382-.424-2.453-1.072-1.043-.648-1.664-1.58-.592-.957-.592-2.255 0-1.608.902-2.82.93-1.214 2.736-1.89 1.805-.676 4.427-.677 3.948 0 6.063 1.692 2.144 1.665 2.087 4.597h-3.666q-.113-1.663-1.41-2.397-1.27-.733-3.215-.733-1.805 0-2.99.536-1.155.535-1.155 1.833 0 .508.282.902.282.367.958.649.678.281 1.834.536 1.156.254 2.876.507 1.608.225 2.905.62 1.325.367 2.256.988.959.592 1.466 1.523.508.93.508 2.284 0 1.664-.874 2.904-.846 1.214-2.651 1.89-1.777.677-4.625.677-2.031 0-3.582-.423-1.551-.451-2.679-1.185-1.128-.732-1.833-1.607t-1.015-1.748q-.282-.875-.226-1.58m23.817 2.172v-3.13h12.07v3.13zM66.423 33l8.573-18.246h4.06L87.716 33h-4.09l-7.501-16.441h1.805L70.484 33zm24.367 0V14.754h12.38q2.115 0 3.666.592 1.58.564 2.454 1.805.874 1.213.874 3.13 0 1.298-.451 2.2a3.84 3.84 0 0 1-1.269 1.467 6.2 6.2 0 0 1-1.833.874q-1.044.282-2.228.366l-.395-.225q1.974.028 3.243.338 1.269.282 1.89 1.072.648.761.648 2.284V33h-3.75v-4.09q0-1.042-.367-1.607-.366-.591-1.326-.817-.93-.226-2.707-.226h-7.078V33zm3.75-9.673h8.63q1.58 0 2.397-.761.846-.762.846-2.059 0-1.24-.846-1.89-.818-.648-2.397-.648h-8.63zm22.82 5.697v-3.13h12.07v3.13zM112.82 33l8.573-18.246h4.061L134.111 33h-4.089l-7.501-16.441h1.805L116.881 33zm28.118-18.246V29.87h12.126V33h-15.877V14.754z"></path>
    <defs>
      <linearGradient
        id="paint0_linear_34151_47857"
        x1="28.719"
        x2="35.952"
        y1="31.251"
        y2="24.835"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#7357E9"></stop>
        <stop offset="1" stopColor="#5735E4"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_34151_47857"
        x1="17.562"
        x2="10.329"
        y1="17.543"
        y2="23.958"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#7357E9"></stop>
        <stop offset="1" stopColor="#5735E4"></stop>
      </linearGradient>
    </defs>
  </svg>
));

SaralLogoPDFPreviewPage.displayName = 'SaralLogoPDFPreviewPage';

export default SaralLogoPDFPreviewPage;
